export default "__VITE_ASSET__Dk0qt5uU__"